import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { z } from "zod";
import { zodParseWithLog } from "src/api/apiErrorLogs.ts";

type SupersetResource = {
    type: string;
    id: string;
};

interface GuestTokenPayload {
    resources: SupersetResource[];
}

export const embeddedSupersetPayloadKey = "embeddedSupersetPayload" as const;

export const useGetEmbeddedSupersetData = (payload: GuestTokenPayload) => {
    return useQuery({
        queryKey: ["getSupersetEmbeddedData", payload],
        cacheTime: 0,
        queryFn: async () => {
            const url = `/api/superset/embedded_payload`;

            return await loggedInApiCall.post<EmbeddedSupersetResponse>(url, payload, {
                headers: { Accept: "application/json" },
            });
        },
        select: (request) => {
            const embeddedPayloadResponse = request.data;

            return zodParseWithLog(embeddedPayloadResponse, EmbeddedSupersetResponseSchema, embeddedSupersetPayloadKey);
        },
    });
};

export type EmbeddedSupersetResponse = {
    hostUrl: string;
    guestToken: { guestToken: string; refreshToken: string };
    urlParams: { company_ids: Array<number> };
};

const EmbeddedSupersetResponseSchema: z.ZodSchema<EmbeddedSupersetResponse> = z.object({
    hostUrl: z.string().url(),
    guestToken: z.object({
        guestToken: z.string(),
        refreshToken: z.string(),
    }),
    urlParams: z
        .object({
            company_ids: z.array(z.number()),
        })
        .catchall(z.unknown()),
});
